import store from '../index';
import types from '../types/zone';
import state from '../state/zone';
import { ZONE_COLORS } from '../../helpers/constants';
import { getZoneColor } from '../../helpers/utils';
import actions from '../actions/zone';

const initialState = state.geoRadarZone;
const initialRivalsByLocationState = state.rivalsByLocation;

export const cancelZoneAction = () => {
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: initialState,
  });
};

export const addZoneAction = () => {
  cancelZoneAction();
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: { ...initialState, isAddOpen: true },
  });
};

export const editZoneAction = (selectedItem) => {
  cancelZoneAction();
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: {
      ...initialState,
      isEditOpen: true,
      selectedZoneItem: selectedItem,
      zoneColor: selectedItem.color
        ? getZoneColor(selectedItem.color)
        : ZONE_COLORS[0],
      zoneOpacity: selectedItem.transparency,
    },
  });
};

export const versionZoneEditAction = (selectedItem) => {
  const prevState = store().getState().zone.geoRadarZone;
  cancelZoneAction();
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: {
      ...initialState,
      isVersionEditOpen: true,
      selectedVersionZoneItem: selectedItem,
      zoneColor: selectedItem.color,
      zoneOpacity: selectedItem.transparency,
      activeExpZoneRow: prevState.activeExpZoneRow,
    },
  });
};

export const filterZoneAction = (isFilterValue = true) => {
  cancelZoneAction();
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: { ...initialState, isFiltersOpen: isFilterValue },
  });
};

export const setZoneColorAction = (color) => {
  const prevState = store().getState().zone.geoRadarZone;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: { ...prevState, zoneColor: color },
  });
};
export const setZoneOpacityAction = (opacity) => {
  const prevState = store().getState().zone.geoRadarZone;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: { ...prevState, zoneOpacity: opacity },
  });
};

export const setSelectedVersionRows = (selectedVersionRowValue) => {
  const prevState = store().getState().zone.geoRadarZone;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: { ...prevState, selectedVersionRows: selectedVersionRowValue },
  });
};
export const setEditPathOfPolygon = (editPathOfPolygonValue) => {
  const prevState = store().getState().zone.geoRadarZone;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: { ...prevState, editPathOfPolygon: editPathOfPolygonValue },
  });
};

export const setVersionEditPathsOfPolygon = (versionEditPathOfPolygonValue) => {
  const prevState = store().getState().zone.geoRadarZone;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: {
      ...prevState,
      versionEditPathsOfPolygon: versionEditPathOfPolygonValue,
    },
  });
};

export const setPathsOfPolygon = (setPathsOfPolygonValue) => {
  const prevState = store().getState().zone.geoRadarZone;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: { ...prevState, pathsOfPolygon: setPathsOfPolygonValue },
  });
};

export const setActiveExpZoneRow = (activeExpZoneRowVal) => {
  const prevState = store().getState().zone.geoRadarZone;

  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: { ...prevState, activeExpZoneRow: activeExpZoneRowVal },
  });
};
export const setDrawnPolygonPaths = (drawnPolygonPathVal) => {
  const prevState = store().getState().zone.geoRadarZone;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: { ...prevState, drawnPolygonPaths: drawnPolygonPathVal },
  });
};

export const setHeatmapDateRange = ({ startDate, finishDate }) => {
  const prevState = store().getState().zone.geoRadarZone;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: { ...prevState, heatmapDateRange: { startDate, finishDate } },
  });
};

export const openHeatmap = () => {
  const prevState = store().getState().zone.geoRadarZone;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: { ...prevState, heatmapToggle: true },
  });
};

export const closeHeatmap = () => {
  const prevState = store().getState().zone.geoRadarZone;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'geoRadarZone',
    data: { ...prevState, heatmapToggle: false, heatmapDateRange: null },
  });
};

export const setSelectedRegionAndStoreFromStores = (data) => {
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'selectedStoreAndRegionFromStore',
    data: data,
  });
};

export const visibleCleanAndResetButton = (visible) => {
  const prevState = store().getState().zone.rivalsByLocation;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'rivalsByLocation',
    data: {
      ...initialRivalsByLocationState,
      rivalsByLocationLatAndLngValue: prevState?.rivalsByLocationLatAndLngValue,
      showCleanAndResetButton: visible,
    },
  });
};
export const setSlotsFromZone = (data) => {
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'slotsFromZone',
    data: data,
  });
};
export const getRivalsByLocation = async () => {
  const prevState = store().getState().zone.rivalsByLocation;
  if (prevState?.rivalsByLocationLatAndLngValue) {
    try {
      const rivalsByLocation = await actions.getRivalsByLocation(
        prevState.rivalsByLocationLatAndLngValue,
      );
      const newMarkers = rivalsByLocation.map((store) => ({
        position: { lat: store.lat, lng: store.lng },
        icon: store.iconUrl || '/static/img/market.svg',
        title: store.name,
      }));
      store().dispatch({
        type: types.ZONE_SET,
        key: 'rivalsByLocation',
        data: {
          ...prevState,
          getRivalsByLocationButtonChangeTitle: true,
          showCleanAndResetButton: false,
          rivalsByLocationMarkers: newMarkers,
        },
      });
      setTimeout(() => {
        store().dispatch({
          type: types.ZONE_SET,
          key: 'rivalsByLocation',
          data: {
            ...prevState,
            getRivalsByLocationButtonChangeTitle: false,
            showCleanAndResetButton: true,
            rivalsByLocationMarkers: newMarkers,
          },
        });
      }, 7000);
    } catch (error) {
      console.error('Error:', error);
    }
  } else {
    visibleCleanAndResetButton(false);
  }
};

export const setSelectedRivalsMarker = (selectedRivalsMarker) => {
  const prevState = store().getState().zone.rivalsByLocation;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'rivalsByLocation',
    data: { ...prevState, selectedRivalsMarker },
  });
};

export const setRivalsByLocationLatAndLngValue = (
  rivalsByLocationLatAndLngValue,
) => {
  const prevState = store().getState().zone.rivalsByLocation;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'rivalsByLocation',
    data: { ...prevState, rivalsByLocationLatAndLngValue },
  });
};

export const setStoreLocationsLatLng = (storeLocationsLatLng) => {
  const prevState =
    store().getState().zone.cityDistrictAndNeighborhoodSelection;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'cityDistrictAndNeighborhoodSelection',
    data: { ...prevState, storeLocationsLatLng },
  });
};
export const setCitySelection = (selectedCity) => {
  const prevState =
    store().getState().zone.cityDistrictAndNeighborhoodSelection;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'cityDistrictAndNeighborhoodSelection',
    data: { ...prevState, selectedCity },
  });
};

export const setDistrictSelected = (selectedDistrict) => {
  const prevState =
    store().getState().zone.cityDistrictAndNeighborhoodSelection;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'cityDistrictAndNeighborhoodSelection',
    data: { ...prevState, selectedDistrict },
  });
};

export const setNeighborhoodSelected = (selectedNeighborhood) => {
  const prevState =
    store().getState().zone.cityDistrictAndNeighborhoodSelection;
  return store().dispatch({
    type: types.ZONE_SET,
    key: 'cityDistrictAndNeighborhoodSelection',
    data: { ...prevState, selectedNeighborhood },
  });
};

export const getGeoRadarZones = async (queryString) => {
  return actions.getGeoRadarZones(queryString);
};
export const getAllGeoRadarZones = async () => {
  return actions.getAllGeoRadarZones();
};
export const getGeoRadarZoneTypes = async () => {
  return actions.getGeoRadarZoneTypes();
};
export const addGeoRadarZone = async (data) => {
  return actions.addGeoRadarZone(data);
};
export const getGeoRadarZoneHistory = async (id) => {
  return actions.getGeoRadarZoneHistory(id);
};
export const cityLocalBoundaries = async (data) => {
  return actions.cityLocalBoundaries(data);
};
export const districtLocalBoundaries = async (data) => {
  return actions.districtLocalBoundaries(data);
};
export const neighborhoodLocalBoundaries = async (data) => {
  return actions.neighborhoodLocalBoundaries(data);
};
export const geoRadarApprove = async (geoRadarZoneData) => {
  return actions.geoRadarApprove(geoRadarZoneData);
};
export const editGeoRadarZone = async (geoRadarZoneData) => {
  return actions.editGeoRadarZone(geoRadarZoneData);
};

export const getIsochroneZone = async (latitude, longitude, doubleTime) => {
  return actions.getIsochroneZone(latitude, longitude, doubleTime);
};
export const editVersionGeoRadarZone = async (geoRadarZoneData) => {
  return actions.editVersionGeoRadarZone(geoRadarZoneData);
};

export const geoRadarZoneMove = async (zoneMoveBody) => {
  return actions.geoRadarZoneMove(zoneMoveBody);
};
export const geoRadarZoneRevert = async (zoneId, data) => {
  return actions.geoRadarZoneRevert(zoneId, data);
};
export const zoneMove = async (zoneMoveBody) => {
  return actions.zoneMove(zoneMoveBody);
};
export const getOrderCountInfoForZoneMove = async (zoneId) => {
  return actions.getOrderCountInfoForZoneMove(zoneId);
};
export const getNeighborhoodBoundariesByRegion = async (regionIds) => {
  return actions.getNeighborhoodBoundariesByRegion(regionIds);
};
export const getDistrictBoundariesByRegion = async (storeId) => {
  return actions.getDistrictBoundariesByRegion(storeId);
};
export const getCityBoundariesByRegion = async (storeId) => {
  return actions.getCityBoundariesByRegion(storeId);
};
export const getOrderCountOfZone = async (data, zoneId) => {
  return actions.getOrderCountOfZone(data, zoneId);
};
export const getAllZonesNearbySelectedZone = async (zoneId) => {
  const prevState = store().getState().zone.geoRadarZone;
  if (zoneId) {
    try {
      const res = await actions.getAllZonesNearbySelectedZone(zoneId);

      store().dispatch({
        type: types.ZONE_SET,
        key: 'geoRadarZone',
        data: { ...prevState, nearbyZones: res.data },
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }
};
export const updateAllZoneDeliveryFees = async (data) => {
  return actions.updateAllZoneDeliveryFees(data);
};
export const updateAllZoneMinimumCartAmount = async (minCartAmount) => {
  return actions.updateAllZoneMinimumCartAmount(minCartAmount);
};

